<template>
  <v-card v-if="options">
    <v-card-title>
      {{ $t("auditor.startEditForm.title") }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t("auditor.startEditForm.subtitle") }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="6">
            <v-dialog
              ref="startEditDateDialog"
              v-model="startEditDateModal"
              :return-value.sync="startEditDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startEditDate"
                  :label="$t('auditor.applicationDeadlineForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="startEditDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startEditDateModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.startEditDateDialog.save(startEditDate)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog
              ref="startEditTimeDialog"
              v-model="startEditTimeModal"
              :return-value.sync="startEditTime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startEditTime"
                  :label="$t('auditor.applicationDeadlineForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker v-if="startEditTimeModal" v-model="startEditTime" format="24hr" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startEditTimeModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.startEditTimeDialog.save(startEditTime)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="update" :loading="loading" color="secondary">
        {{ $t("auditor.applicationDeadlineForm.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UpdateOptionMutation from "@/gql/mutations/UpdateOptionMutation.gql";
import OptionsQuery from "@/gql/queries/auditor/OptionsQuery.gql";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      startEditDateModal: false,
      startEditTimeModal: false,
      options: null,
      startEditDate: null,
      startEditTime: null,
    };
  },

  apollo: {
    options: {
      query: OptionsQuery,
      fetchPolicy: "network-only",
      update(data) {
        if (data.options) {
          this.startEditDate = data.options.find((option) => option.key === "startEdit")?.value.substr(0, 10);
          this.startEditTime = data.options.find((option) => option.key === "startEdit")?.value.substr(11, 5);
        }

        return data.options;
      },
    },
  },

  computed: {
    startEdit() {
      return `${this.startEditDate}T${this.startEditTime}:00.000Z`;
    },
  },

  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: UpdateOptionMutation,
        variables: {
          key: "startEdit",
          value: this.startEdit,
        },
      });

      this.loading = false;
    },
  },
};
</script>
